export const NUMBER_OF_BRANDS_PER_PAGE = 15
export const TRIGGERED_BY_LABEL = 'cashback from'
